"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClipboard = void 0;
const react_1 = require("react");
function useClipboard(onSuccess) {
    return (0, react_1.useCallback)((value) => {
        void navigator.clipboard.writeText(value);
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
    }, [onSuccess]);
}
exports.useClipboard = useClipboard;
